import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

/**
 * Opciones de configuración para el QueryProvider
 */
export interface QueryProviderOptions {
  /**
   * Tiempo en milisegundos que los datos se consideran frescos
   * @default 1000 * 60 * 5 (5 minutos)
   */
  staleTime?: number;

  /**
   * Tiempo en milisegundos que los datos inactivos permanecen en cache
   * @default 1000 * 60 * 30 (30 minutos)
   */
  gcTime?: number;

  /**
   * Número de reintentos en caso de error
   * @default 3
   */
  retry?: number | boolean;

  /**
   * Si se debe refetch al enfocar la ventana
   * @default true
   */
  refetchOnWindowFocus?: boolean;
}

interface QueryProviderProps extends QueryProviderOptions {
  children: ReactNode;
}

/**
 * Provider de TanStack Query configurado para la tabla
 * Envuelve los componentes que necesitan acceso a queries
 */
export function TableQueryProvider({
  children,
  staleTime = 1000 * 60 * 5, // 5 minutos
  gcTime = 1000 * 60 * 30, // 30 minutos
  retry = 3,
  refetchOnWindowFocus = true,
}: QueryProviderProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime,
            gcTime,
            retry,
            refetchOnWindowFocus,
          },
        },
      })
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
